import { render, staticRenderFns } from "./MessageTemplatesDialog.vue?vue&type=template&id=c7d79dcc&"
import script from "./MessageTemplatesDialog.vue?vue&type=script&lang=js&"
export * from "./MessageTemplatesDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplatesDialog.vue?vue&type=style&index=0&id=c7d79dcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports